import { SecurityRoleType } from '@jms/model';
import type { SuggestRole } from '../agent.types';

/**
 * Map a tenant security role name (from CurrentUserService.$role().name) to the
 * normalised SuggestRole used to pick a suggestion set.
 *
 * Technician is folded into Operations for v1 — dedicated mobile/field persona deferred.
 */
export function mapRoleToSuggestRole(roleName: string | undefined | null): SuggestRole {

  switch (roleName) {
    case SecurityRoleType.EmployeeOwner:
    case SecurityRoleType.EmployeeAdministrator:
    case SecurityRoleType.SystemAdministrator:
      return 'administrator';
    case SecurityRoleType.EmployeeOperations:
    case SecurityRoleType.EmployeeCompliance:
    case SecurityRoleType.EmployeeTechnician:
      return 'operations';
    case SecurityRoleType.EmployeeScheduler:
      return 'scheduler';
    case SecurityRoleType.EmployeeFinance:
      return 'finance';
    default:
      return 'fallback';
  }
}
